import React from 'react';
import Dashboard from './Dashboard';
import PriorityQueue from './PriorityQueue';
import QualityMetrics from '../shared/QualityMetrics';
import AccessMetrics from '../shared/AccessMetrics';
import StaffingAlerts from '../shared/StaffingAlerts';
import ConsumerInsights from '../shared/ConsumerInsights';
import ManagerFinanceTab from './ManagerFinanceTab';
import ManagerInitiativesTab from './ManagerInitiativesTab';
import useTabFromUrl from '../../hooks/useTabFromUrl';

function ManagerView({ user, initialTab }) {
  const [activeTab] = useTabFromUrl(initialTab || 'dashboard');

  return (
    <div className="tab-content">
      {activeTab === 'dashboard' && <Dashboard unitId={user.unitId} />}
      {activeTab === 'priority' && <PriorityQueue unitId={user.unitId} />}
      {activeTab === 'access' && <AccessMetrics unitId={user.unitId} level="unit" />}
      {activeTab === 'quality' && <QualityMetrics unitId={user.unitId} level="unit" />}
      {activeTab === 'staffing' && <StaffingAlerts unitId={user.unitId} level="unit" />}
      {activeTab === 'finance' && <ManagerFinanceTab unitId={user.unitId} />}
      {activeTab === 'consumer' && <ConsumerInsights unitId={user.unitId} level="unit" />}
      {activeTab === 'initiatives' && <ManagerInitiativesTab unitId={user.unitId} />}
    </div>
  );
}

export default ManagerView;
